export class ToasterMessage {
    constructor() {}

    titleInformation = 'toast.titreinfo';

    M04 = 'toast.M04';
    M05 = 'toast.M05';
    M06 = 'toast.M06';
    M07 = 'toast.M07';
    M08 = 'toast.M08';

    error = 'toast.error';
    errorTitle = 'toast.errorTitle';
    saveSuccess = 'toast.saveSuccess';
    saveSuccessTitle = 'toast.saveSuccessTitle';
    sendSuccess = 'toast.sendSuccess';
    sendSuccessTitle = 'toast.sendSuccessTitle';
    sendFailXSD = 'toast.sendFailXSD';

}
